import DataProvider from 'api/data-provider';
import cacheTemrs from 'helpers/cacheTerms';

import { BACKEND_LIMIT, DEFAULT_COMMENT_LIMIT, LIST_URL } from './config';

/**
 * Comments preloader helper
 * Query field order must repeat same order in data provider - because cache
 *
 * @param props
 * @return {*[]}
 */
export default function commentsPreloader(props) {
  const fullList = props.full ? BACKEND_LIMIT : null;
  return {
    commentsList: [DataProvider.preload, {
      url: props.url || LIST_URL,
      cache: cacheTemrs.commentsList,
      query: {
        entity: props.entity,
        entityId: props.entityId,
        limit: fullList || props.limit || DEFAULT_COMMENT_LIMIT,
        count: true,
        $auth: false
      }
    }]
  };
}
